const SHORT: Record<string, string> = {
	low: 'Быстрое',
	medium: 'Среднее',
	high: 'Высокое',
	xhigh: 'Очень высокое',
	max: 'Максимальное',
}

const FULL: Record<string, string> = {
	low: 'Быстрое (Low)',
	medium: 'Среднее (Medium)',
	high: 'Высокое (High)',
	xhigh: 'Очень высокое (XHigh)',
	max: 'Максимальное (Max)',
}

export function qualityLabelShort(quality?: string | null): string {
	return SHORT[quality || ''] || SHORT.medium
}

export function qualityLabelFull(quality?: string | null): string {
	return FULL[quality || ''] || FULL.medium
}
